module.exports = __webpack_public_path__ + "img/aclogoAlterna-Logo@3x.6ce79b4a.png";